/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const idxModal = () => {
		$('.idx-modal').on('click', (e) => {
			let HTML = '<div class="idx-modal-overlay">';
			HTML +=
				'<div class="idx-modal-content opacity">'+
				'<div class="idx-modal-content-in">'+
				'<figure><img src="'+ $(e.currentTarget).data('img') +'" alt="'+ $(e.currentTarget).data('item') +'"></figure>'+
				'<p>'+ $(e.currentTarget).data('c_name') +'</p>'+
				'<table class="mod-tbl01">'+
				'<tr>'+
				'<th>住所</th>'+
				'<td>'+ $(e.currentTarget).data('address') +'<br>'+
				'<a class="pos_relative pr40" href="'+ $(e.currentTarget).data('g_link') +'" target="_blank"><span>Google Map<svg class="mod-iconRight icon _blank"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg></span></a></td>'+
				'</tr>'+
				'<tr>'+
				'<th>最寄り駅</th>'+
				'<td>'+ $(e.currentTarget).data('station') +'</td>'+
				'</tr>'+
				'<tr>'+
				'<th>TEL</th>'+
				'<td>'+ $(e.currentTarget).data('tel') +'</td>'+
				'</tr>'+
				'<tr>'+
				'<th>営業時間</th>'+
				'<td>'+ $(e.currentTarget).data('hour') +'</td>'+
				'</tr>'+
				'<tr>'+
				'<th>公式Instagram</th>'+
				'<td>'+'<a href="https://www.instagram.com/lasoeurauxbacchanales_official/" target="_blank">'+ $(e.currentTarget).data('instagram') +'</a>'+'</td>'+
				'</tr>'+
				'</table>'+
				'<a class="mod-button _315 mt50 sp_mt100" href="https://www.ozmall.co.jp/restaurant/7572/" target="_blank"><span>ご予約はこちら<svg class="mod-iconRight icon _blank"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg></span></a>'+
				'</div>'+
				'<span class="idx-modal-closeBtn"><span></span></span>'+
				'</div>'+
				'<div class="idx-modal-closeArea"></div></div>';
				$('body').append(HTML);
				const $overlay = $('.idx-modal-overlay');
				$overlay.addClass(a);
				var $body = $('body');
				var scrollTop;
				scrollTop = $(window).scrollTop();
				$body.css({
					'position': 'fixed',
					'width': '100%',
					'top': -scrollTop
				});
				setTimeout(() => {
					$overlay.addClass(v);
					$('.idx-modal-closeArea, .idx-modal-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						$body.css({
							position: '',
							top: ''
						  });
						  $(window).scrollTop(scrollTop);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
		});
	};
	idxModal();

	const idxModal02 = () => {
		$('.idx-modal02').on('click', (e) => {
			let HTML = '<div class="idx-modal-overlay">';
			HTML +=
				'<div class="idx-modal-content opacity">'+
				'<div class="idx-modal-content-in">'+
				'<figure><img src="'+ $(e.currentTarget).data('img') +'" alt="'+ $(e.currentTarget).data('item') +'"></figure>'+
				'<p>'+ $(e.currentTarget).data('c_name') +'</p>'+
				'<table class="mod-tbl01">'+
				'<tr>'+
				'<th>住所</th>'+
				'<td>'+ $(e.currentTarget).data('address') +'<br>'+
				'<a class="pos_relative pr40" href="'+ $(e.currentTarget).data('g_link') +'" target="_blank"><span>Google Map<svg class="mod-iconRight icon _blank"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg></span></a></td>'+
				'</tr>'+
				'<tr>'+
				'<th>最寄り駅</th>'+
				'<td>'+ $(e.currentTarget).data('station') +'</td>'+
				'</tr>'+
				'<tr>'+
				'<th>TEL</th>'+
				'<td>'+ $(e.currentTarget).data('tel') +'</td>'+
				'</tr>'+
				'<tr>'+
				'<th>営業時間</th>'+
				'<td>'+ $(e.currentTarget).data('hour') +'</td>'+
				'</tr>'+
				'<tr>'+
				'<th>公式Instagram</th>'+
				'<td>'+'<a href="https://www.instagram.com/barissimo_official_yurakucho/" target="_blank">'+ $(e.currentTarget).data('instagram') +'</a>'+'</td>'+
				'</tr>'+
				'</table>'+
				'</div>'+
				'<span class="idx-modal-closeBtn"><span></span></span>'+
				'</div>'+
				'<div class="idx-modal-closeArea"></div></div>';
			$('body').append(HTML);
			const $overlay = $('.idx-modal-overlay');
			$overlay.addClass(a);
			var $body = $('body');
				var scrollTop;
				scrollTop = $(window).scrollTop();
				$body.css({
					'position': 'fixed',
					'width': '100%',
					'top': -scrollTop
				});
			setTimeout(() => {
				$overlay.addClass(v);
				$('.idx-modal-closeArea, .idx-modal-closeBtn').on('click', () => {
					$overlay.removeClass(v);
					$body.css({
						position: '',
						top: ''
					  });
					  $(window).scrollTop(scrollTop);
					setTimeout(() => {
						$overlay.removeClass(a);
						$overlay.remove();
					}, 400);
				});
			});
		});
	};
	idxModal02();

	const idxModal03 = () => {
		$('.idx-modal03').on('click', (e) => {
			let HTML = '<div class="idx-modal-overlay">';
			HTML +=
				'<div class="idx-modal-content opacity">'+
				'<div class="idx-modal-content-in logoSmall">'+
				'<figure><img src="'+ $(e.currentTarget).data('img') +'" alt="'+ $(e.currentTarget).data('item') +'"></figure>'+
				'<p>'+ $(e.currentTarget).data('c_name') +'</p>'+
				'<table class="mod-tbl01">'+
				'<tr>'+
				'<th>住所</th>'+
				'<td>'+ $(e.currentTarget).data('address') +'<br>'+
				'<a class="pos_relative pr40" href="'+ $(e.currentTarget).data('g_link') +'" target="_blank"><span>Google Map<svg class="mod-iconRight icon _blank"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg></span></a></td>'+
				'</tr>'+
				'<tr>'+
				'<th>最寄り駅</th>'+
				'<td>'+ $(e.currentTarget).data('station') +'</td>'+
				'</tr>'+
				'<tr>'+
				'<th>TEL</th>'+
				'<td>'+ $(e.currentTarget).data('tel') +'</td>'+
				'</tr>'+
				'<tr>'+
				'<th>営業時間</th>'+
				'<td>'+ $(e.currentTarget).data('hour') +'</td>'+
				'</tr>'+
				'</table>'+
				'</div>'+
				'<span class="idx-modal-closeBtn"><span></span></span>'+
				'</div>'+
				'<div class="idx-modal-closeArea"></div></div>';
				$('body').append(HTML);
				const $overlay = $('.idx-modal-overlay');
				$overlay.addClass(a);

				var $body = $('body');
				var scrollTop;
				scrollTop = $(window).scrollTop();
				$body.css({
					'position': 'fixed',
					'width': '100%',
					'top': -scrollTop
				});
				setTimeout(() => {
					$overlay.addClass(v);
					$('.idx-modal-closeArea, .idx-modal-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						$body.css({
							position: '',
							top: ''
						  });
						  $(window).scrollTop(scrollTop);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
		});
	};
	idxModal03();

})(window.jQuery, window.FUNCTIONS);
